import React, { useEffect, useState } from 'react';
import axios from 'axios';
import UnitSelectionBanner from '../../components/unitSelection/unitSelectionBanner';
import Header from "../../shared/header";
import PagesFooter from "../../shared/pagesFooter";
import { useParams } from 'react-router-dom';

const UnitSelectionPage = () => {
  const [data, setData] = useState(null);
  const { floor, unitNumber } = useParams();
  console.log('UnitLayOut', floor, unitNumber);

  useEffect(() => {
    // Fetch data from the API
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}property/statusGroupedTotal?floor=${floor}`);
        console.log('statusGroupedTotal', response);
        setData(response.data.body);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, [floor, unitNumber]);

  // Render the banner only if the data is available
  return (
    <div>
      <div className='unit-selection-header'>
        <Header />
      </div>
      {data ? (
        <UnitSelectionBanner floor={floor} data={data} />
      ) : (
        <p>Loading data...</p> // Display loading text or spinner while data is being fetched
      )}
      <PagesFooter />
    </div>
  );
};

export default UnitSelectionPage;
